if (!customElements.get("product-media-zoom-popup")) {
  customElements.define(
    "product-media-zoom-popup",
    class ProductMediaZoomPopup extends HTMLElement {
      constructor() {
        super();
        this.isOpen = false;
        this.init();
      }

      init() {
        this.closeBtn = this.querySelector(".zoom-close-btn");
        this.scrollContainer = this.querySelector(".zoom-media-scroll-container");
        this.setupEventListeners();
      }

      setupEventListeners() {
        // Close button
        if (this.closeBtn) {
          this.closeBtn.addEventListener("click", () => this.close());
        }

        // Close on background click
        this.addEventListener("click", (e) => {
          if (e.target === this) {
            this.close();
          }
        });

        // Close on Escape key
        document.addEventListener("keydown", (e) => {
          if (e.key === "Escape" && this.isOpen) {
            this.close();
          }
        });
      }

      open(mediaId = null, slideIndex = null) {
        this.isOpen = true;
        this.classList.remove("hidden");
        this.classList.add("flex");

        // Set initial animation state
        this.style.opacity = "0";
        this.style.transition = "opacity 0.3s ease-out";

        const content = this.querySelector(".zoom-popup-content");
        if (content) {
          content.style.transform = "scale(0.95)";
          content.style.transition = "transform 0.3s ease-out";
        }

        // Trigger animation after a frame
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.style.opacity = "1";
            if (content) {
              content.style.transform = "scale(1)";
            }
          });
        });

        document.body.style.overflow = "hidden";

        // Scroll to specific media item if provided
        if (mediaId || slideIndex !== null) {
          setTimeout(() => {
            this.scrollToMedia(mediaId, slideIndex);
          }, 100);
        } else {
          // Reset scroll to top
          if (this.scrollContainer) {
            this.scrollContainer.scrollTop = 0;
          }
        }
      }

      close() {
        this.isOpen = false;

        // Animate out
        this.style.opacity = "0";
        const content = this.querySelector(".zoom-popup-content");
        if (content) {
          content.style.transform = "scale(0.95)";
        }

        // Hide after animation completes
        setTimeout(() => {
          this.classList.remove("flex");
          this.classList.add("hidden");
          // Reset transforms
          this.style.opacity = "";
          this.style.transition = "";
          if (content) {
            content.style.transform = "";
            content.style.transition = "";
          }
        }, 300);

        document.body.style.overflow = "";
        this.pauseAllMedia();
      }

      scrollToMedia(mediaId, slideIndex) {
        let targetElement = null;

        if (mediaId) {
          targetElement = this.querySelector(
            `.zoom-media-item[data-media-id="${mediaId}"]`
          );
        } else if (slideIndex !== null) {
          const mediaItems = this.querySelectorAll(".zoom-media-item");
          targetElement = mediaItems[slideIndex];
        }

        if (targetElement && this.scrollContainer) {
          const offsetTop = targetElement.offsetTop;
          this.scrollContainer.scrollTo({
            top: offsetTop - 24, // Account for padding
            behavior: "smooth",
          });
        }
      }

      pauseAllMedia() {
        this.querySelectorAll("video").forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });

        this.querySelectorAll("iframe").forEach((iframe) => {
          const currentSrc = iframe.src;
          if (currentSrc.includes("youtube.com")) {
            // Use YouTube iframe API to pause video without reloading
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (currentSrc.includes("vimeo.com")) {
            // Use Vimeo iframe API to pause video without reloading
            iframe.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        });
      }

      disconnectedCallback() {
        document.body.style.overflow = "";
      }
    }
  );
}
